export const BuildConfig = {
  xRoute: 'GRYLS@#HGFG%$JHGH&@#$6754',
  productArray: 'AXUTRAUSKXT/PRODUCT[]',
  wishlistArray: 'MXRSI*&XTS/WISH[]',
  cartCount: 'AGGRH%VDWRE/CART&COUNT',
  wishCount: 'RXYSU#%&S/WISH&COUNT',
};
